import React from "react";
import { useTranslation } from "react-i18next";
import LegalDocumentView, { LegalSection } from "./LegalDocumentView";

const ProductTerms: React.FC = () => {
  const { t } = useTranslation();

  const sections: LegalSection[] = [
    {
      title: t("legal.productTerms.sections.general.title"),
      subsections: t("legal.productTerms.sections.general.subsections", {
        returnObjects: true,
      }) as Array<{
        number: string;
        text: string | Array<string | { text: string; strong?: boolean; linkUrl?: string }>;
      }>,
    },
    {
      title: t("legal.productTerms.sections.delivery.title"),
      subsections: t("legal.productTerms.sections.delivery.subsections", {
        returnObjects: true,
      }) as Array<{
        number: string;
        text: string | Array<string | { text: string; strong?: boolean; linkUrl?: string }>;
      }>,
    },
    {
      title: t("legal.productTerms.sections.useOfProducts.title"),
      subsections: t("legal.productTerms.sections.useOfProducts.subsections", {
        returnObjects: true,
      }) as Array<{
        number: string;
        text: string;
      }>,
    },
    {
      title: t("legal.productTerms.sections.payment.title"),
      subsections: t("legal.productTerms.sections.payment.subsections", {
        returnObjects: true,
      }) as Array<{
        number: string;
        text: string;
      }>,
    },
    {
      title: t("legal.productTerms.sections.delays.title"),
      subsections: t("legal.productTerms.sections.delays.subsections", {
        returnObjects: true,
      }) as Array<{
        number: string;
        text: string;
      }>,
    },
    {
      title: t("legal.productTerms.sections.defects.title"),
      subsections: t("legal.productTerms.sections.defects.subsections", {
        returnObjects: true,
      }) as Array<{
        number: string;
        text: string;
      }>,
    },
    {
      title: t("legal.productTerms.sections.returns.title"),
      subsections: t("legal.productTerms.sections.returns.subsections", {
        returnObjects: true,
      }) as Array<{
        number: string;
        text: string | Array<string | { text: string; strong?: boolean; linkUrl?: string }>;
      }>,
    },
    {
      title: t("legal.productTerms.sections.productLiability.title"),
      subsections: t("legal.productTerms.sections.productLiability.subsections", {
        returnObjects: true,
      }) as Array<{
        number: string;
        text: string | Array<string | { text: string; strong?: boolean; linkUrl?: string }>;
      }>,
    },
    {
      title: t("legal.productTerms.sections.limitationOfLiability.title"),
      subsections: t("legal.productTerms.sections.limitationOfLiability.subsections", {
        returnObjects: true,
      }) as Array<{
        number: string;
        text: string | Array<string | { text: string; strong?: boolean; linkUrl?: string }>;
      }>,
    },
    {
      title: t("legal.productTerms.sections.governingLaw.title"),
      subsections: t("legal.productTerms.sections.governingLaw.subsections", {
        returnObjects: true,
      }) as Array<{
        number: string;
        text: string | Array<string | { text: string; strong?: boolean; linkUrl?: string }>;
      }>,
    },
  ];

  return (
    <div className="space-y-6">
      <header className="border-b border-slate-200 pb-6">
        <h2 className="text-3xl font-bold tracking-tight text-slate-950 md:text-4xl">
          {t("legal.productTerms.title")}
        </h2>
        <p className="mt-3 text-base font-medium text-blue-700">
          {t("legal.productTerms.subtitle")}
        </p>
        <p className="mt-4 max-w-4xl text-base leading-8 text-slate-700 md:text-lg">
          {t("legal.productTerms.description")}
        </p>
      </header>

      <LegalDocumentView sections={sections} />
    </div>
  );
};

export default ProductTerms;
